module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topicAdd"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("话题PK")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("添加话题")])], 1), _vm._v(" "), _c('div', {
    staticClass: "topic-add-box"
  }, [_c('el-form', {
    ref: "addTopicForm",
    staticClass: "addTopicForm",
    attrs: {
      "model": _vm.addTopicForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "话题名称",
      "prop": "topicTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入话题名称"
    },
    model: {
      value: (_vm.addTopicForm.topicTitle),
      callback: function($$v) {
        _vm.addTopicForm.topicTitle = $$v
      },
      expression: "addTopicForm.topicTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "焦点图类别",
      "prop": "focusImgType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addTopicForm.focusImgType),
      callback: function($$v) {
        _vm.addTopicForm.focusImgType = $$v
      },
      expression: "addTopicForm.focusImgType"
    }
  }, _vm._l((_vm.focusImgType), function(typeItem) {
    return _c('el-option', {
      key: typeItem.value,
      attrs: {
        "label": typeItem.label,
        "value": typeItem.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.addTopicForm.focusImgType === 'image') ? _c('el-form-item', {
    attrs: {
      "label": "焦点图",
      "prop": "focusImgUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入焦点图地址"
    },
    model: {
      value: (_vm.addTopicForm.focusImgUrl),
      callback: function($$v) {
        _vm.addTopicForm.focusImgUrl = $$v
      },
      expression: "addTopicForm.focusImgUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addTopicForm.focusImgType === 'video') ? _c('el-form-item', {
    attrs: {
      "label": "焦点视频",
      "prop": "focusImgUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入焦点图地址"
    },
    model: {
      value: (_vm.addTopicForm.focusImgUrl),
      callback: function($$v) {
        _vm.addTopicForm.focusImgUrl = $$v
      },
      expression: "addTopicForm.focusImgUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addTopicForm.focusImgType === 'video') ? _c('el-form-item', {
    attrs: {
      "label": "视频封皮",
      "prop": "focusVideoPoster"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入视频封皮地址"
    },
    model: {
      value: (_vm.addTopicForm.focusVideoPoster),
      callback: function($$v) {
        _vm.addTopicForm.focusVideoPoster = $$v
      },
      expression: "addTopicForm.focusVideoPoster"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "话题内容",
      "prop": "topicContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off",
      "placeholder": "请输入话题内容（选填）"
    },
    model: {
      value: (_vm.addTopicForm.topicContent),
      callback: function($$v) {
        _vm.addTopicForm.topicContent = $$v
      },
      expression: "addTopicForm.topicContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参与人数",
      "prop": "participants"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入参与人数（选填）"
    },
    model: {
      value: (_vm.addTopicForm.participants),
      callback: function($$v) {
        _vm.addTopicForm.participants = $$v
      },
      expression: "addTopicForm.participants"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启分享",
      "prop": "isShare"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.addTopicForm.isShare),
      callback: function($$v) {
        _vm.addTopicForm.isShare = $$v
      },
      expression: "addTopicForm.isShare"
    }
  })], 1), _vm._v(" "), (Number(_vm.addTopicForm.isShare)) ? [_c('el-form-item', {
    attrs: {
      "label": "分享图（尺寸200*200）",
      "prop": "shareImgUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入分享图地址"
    },
    model: {
      value: (_vm.addTopicForm.shareImgUrl),
      callback: function($$v) {
        _vm.addTopicForm.shareImgUrl = $$v
      },
      expression: "addTopicForm.shareImgUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享标题",
      "prop": "shareTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入分享标题"
    },
    model: {
      value: (_vm.addTopicForm.shareTitle),
      callback: function($$v) {
        _vm.addTopicForm.shareTitle = $$v
      },
      expression: "addTopicForm.shareTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享描述",
      "prop": "shareDes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off",
      "placeholder": "请输入分享描述"
    },
    model: {
      value: (_vm.addTopicForm.shareDes),
      callback: function($$v) {
        _vm.addTopicForm.shareDes = $$v
      },
      expression: "addTopicForm.shareDes"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addTopic('addTopicForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.clearTopicData()
      }
    }
  }, [_vm._v("重置")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "topic-preview-box"
  }, [(_vm.addTopicForm.focusImgUrl !== null && _vm.addTopicForm.focusImgUrl !== '') ? _c('div', {
    staticClass: "header-image"
  }, [(_vm.addTopicForm.focusImgType === 'image') ? _c('img', {
    attrs: {
      "src": _vm.addTopicForm.focusImgUrl,
      "alt": "请输入正确的图片地址"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addTopicForm.focusImgType === 'video') ? _c('video', {
    attrs: {
      "src": _vm.addTopicForm.focusImgUrl,
      "poster": _vm.addTopicForm.focusVideoPoster,
      "controls": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.addTopicForm.topicTitle !== null && _vm.addTopicForm.topicTitle !== '') ? _c('div', {
    staticClass: "description"
  }, [_c('h5', [_vm._v(_vm._s(_vm.addTopicForm.topicTitle))]), _vm._v(" "), (_vm.addTopicForm.topicContent !== null && _vm.addTopicForm.topicContent !== '') ? _c('span', {
    staticClass: "desc-content"
  }, [_vm._v(_vm._s(_vm.addTopicForm.topicContent))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.addTopicForm.topicTitle !== null && _vm.addTopicForm.topicTitle !== '') ? _c('div', {
    staticClass: "say-sth"
  }, [_c('img', {
    attrs: {
      "src": "http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/ydlg1495784109418.jpeg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("一点资讯用户")]), _vm._v(" "), _c('div', [_vm._v("说点什么")])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ec2cf880"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/topic/Add.vue
// module id = 798
// module chunks = 1